import { get } from "../index";

export const getIdeas = (data) => {
    let query = "";
    for (let d in { ...data })
        query +=
            data[d] || (data[d] == 0 && data[d] !== "")
                ? d + "=" + data[d] + "&"
                : "";
    return get(`/ideas?` + query);
};

export const getIdeaByID = (id) => {
    return get(`/ideas/${id}`);
};
